import React, { FunctionComponent } from 'react';
import { Box } from '@material-ui/core';
import FeatureServicePlanItem from '../featureServicePlanItem/FeatureServicePlanItem';
import IFeature from '../../../../../../model/IFeature';
import useCustomizeCarContext from '../../../../../../hooks/useCustomizeCarContext';

export interface IFeatureServicePlanItemListProps {
  features: IFeature[];
  onClick: (code: string) => void;
}

const FeatureServicePlanItemList: FunctionComponent<IFeatureServicePlanItemListProps> = ({ features, onClick }) => {
  const { optimisticSelectedFeatures } = useCustomizeCarContext();

  return (
    <Box data-test="customise:section:servicePlan">
      {features.map(feature => (
        <Box mb={3} key={feature.code}>
          <FeatureServicePlanItem
            feature={feature}
            selected={optimisticSelectedFeatures?.includes(feature.code)}
            onClick={onClick}
          />
        </Box>
      ))}
    </Box>
  );
};

export default FeatureServicePlanItemList;
